import React, { Component } from 'react';
// import '../../App.css';
import { connect } from 'react-redux';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import LevelList from './editTiers/levelList.js';
import Footer from './Footer.js';
import TopNav from '../includes/TopNav';
import {Helmet} from 'react-helmet';

const styles = {
    localH1: { 
        fontSize: '36px',
    },
    localH2: { 
        fontSize: '28px',
    },
    onlyParagraph: { 
        fontSize: '20px',
        lineHeight: '26px',
    },
    instructionList: { 
        paddingTop: '10px',
        listStyleType: 'disc',
    },
    instructionListItem: { 
        paddingTop: '10px',
    },
}
class Preparations extends Component{

    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                <Helmet>
                    <title>Professional Edited Paper Markup Guide | Edit My Paper</title>
                    <meta name="description" content="It is essential that you Accept or Reject all of your editor's changes and remove his/her comments prior to submitting your document."></meta>
                    <meta name="keywords" content="Edit,My,Paper,Editing,Examples,University,College,Students"></meta>
                    <link rel="canonical" href="https://editmypaper.ca/preparations" />
                </Helmet>
                <TopNav />
                <section className="steps top_section">
                    <div className="steps-container">
                        <center>
                            <h1 style={styles.localH1}>Working With Your Completed Paper</h1>
                            <h2 style={styles.localH2}>Thank you for choosing Edit My Paper! It is essential that you Accept or Reject all of your editor's changes and remove his/her comments prior to submitting your document. Should you have additional questions after reading this, please email us at info @ editmypaper.ca.</h2>
                        </center>
                        <div style={styles.onlyParagraph}>
                            To Accept or Reject your editor's changes:
                            <ul style={styles.instructionList}>
                                <li style={styles.instructionListItem}>Open your document with Microsoft Word. If it prompts you to enable editing, please do so. To view the changes your editor made: click the Review tab at the top, and select "Final Showing Markup" or "All Markup" (as seen in the first image below). 
    Once you do this, you can view your editor's changes and either 1) accept all changes by: clicking the Review tab (at the top of Microsoft Word) --> click the small arrow below 'Accept' --> Click 'Accept All Changes and Stop Tracking' (seen in the first image) OR 2) right click on each change in your document and click accept or reject to deal with each individually. If you choose to go through each change individually, please follow step #1 ("Accept All Changes and Stop Tracking) to ensure there are no small edits left.</li>
                                <li style={styles.instructionListItem}>Once you have accepted or rejected the changes, review your document to ensure no editor comments are left. Hiding your editor's comments does not hide them from your teacher/professor. You can right click and delete each comment individually or view the instructions below. You may also want to run Microsoft's Document Inspector once you've accepted/rejected all changes and deleted all comments - this will ensure your document is 'clean' in preparation for submitting it electronically (to Turnitin, blackboard, email, edline etc). However, simply ensuring that you "Accepted All Changes and Stop Tracking" (Step #1 above) and deleted all comments is sufficient. If you are printing your document, you do not need to delete your editor's comments, but we recommend you review all comments and then delete them.</li>
                                <li style={styles.instructionListItem}>The images below will guide you through accepting or rejecting all changes and removing all editor's comments.</li>
                                <li style={styles.instructionListItem}>
                                    To view all changes:<br />
                                    <img src="images/editing/allview.jpg"/>
                                </li>
                                <li style={styles.instructionListItem}>
                                    You can: 1- Accept all changes:<br />
                                    <img src="images/editing/Acceptingall.jpg"/>
                                </li>
                                <li style={styles.instructionListItem}>
                                    
                                    Or you can: 2- Accept or Reject individual changes:<br />
                                    <img src="images/editing/AcceptingIndividualchange.jpg"/>
                                </li>
                                <li style={styles.instructionListItem}>
                                    
                                    To delete all editor comments you can right click on each comment or delete them all: 1- Click on ANY one of your comments 2- Click on the Review tab -->Click on the drop down arrow below the tab "Delete" and click "Delete all comments in document"<br />
                                    <img src="images/editing/deleteallcomments.jpg"/>
                                </li>
                                <li style={styles.instructionListItem}>
                                    After accepting or rejecting all changes, you have to delete all editor comments if you have not already done so. To delete each individually:<br />
                                    <img src="images/editing/deletingcomment.jpg"/>
                                </li>
                                <li style={styles.instructionListItem}>
                                    To delete ALL comments and editor marks, ensure you are satisfied with your essay prior to using the Document Inspector and save your document: (If you are having difficulty with this step, simply email your essay to us at info@editmypaper.ca (remember to include your essay) and we'll send you a final version so you can submit it electronically.
                                    This is unnecessary if you are printing out your essay, however, if your professor requires you to scan it online for plagiarism, you must ensure you have accepted/rejected all edits and deleted all comments.)<br />
                                    <img src="images/editing/Docinspect.jpg" />
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>
                <Footer></Footer>
            </div>
        )
    }
}

export default connect(
  )(Preparations);
  


// WEBPACK FOOTER //
// ./src/components/pages/Preparations.js